import { Phone, MessageSquare, CalendarClock, AlertTriangle } from "lucide-react";
import { COMPANY } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Link } from "react-router-dom";
import { onCallClick, onTextClick } from "@/lib/dialer";

export default function EmergencyBanner() {
  const { t } = useLang();
  const msg = t("emergency");
  const dot = "•";
  return (
    <div className="bg-red-600/95 text-white" data-testid="emergency-banner">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-2 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm">
        <div className="flex items-center gap-2">
          <AlertTriangle className="size-4 shrink-0" />
          <span className="font-semibold tracking-wide">{msg}</span>
          <span className="hidden sm:inline opacity-80">{dot}</span>
          <span className="hidden sm:inline">{t("emergency_sub")}</span>
        </div>
        <div className="flex items-center gap-2">
          <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} className="bg-white text-red-700 font-bold px-3 py-1 rounded-full text-xs flex items-center gap-1.5" data-testid="emerg-call">
            <Phone className="size-3.5" /> {COMPANY.phone}
          </a>
          <a href={COMPANY.sms} onClick={onTextClick} className="bg-white/15 ring-1 ring-white/30 px-3 py-1 rounded-full text-xs flex items-center gap-1.5" data-testid="emerg-text">
            <MessageSquare className="size-3.5" /> Text
          </a>
          <Link to="/schedule" className="bg-white/15 ring-1 ring-white/30 px-3 py-1 rounded-full text-xs flex items-center gap-1.5" data-testid="emerg-schedule">
            <CalendarClock className="size-3.5" /> Schedule
          </Link>
        </div>
      </div>
    </div>
  );
}
